/**
 * The notes composer's placeholder, verbatim from the content-review notes
 * design (v10). Its own module, importing nothing, so the brand e2e spec can
 * find the composer by it without the app's bundler.
 */
export const NOTES_COMPOSER_PLACEHOLDER = 'Write a note for the ops team…';
